import {Grid, Show} from 'platform/foundation';

import {isNil, isNotNil} from 'ramda';

import {getNewVehicleEnumLabel, OptionCard} from '@dms/features/new-vehicle';
import i18n from '@dms/i18n';

import {WHEEL_GROUP_NAME, type WheelSet} from '../utils/getWheelSet';

const t = (key: string, defaultValue: string) => i18n.t(key, {defaultValue});

type Props = {
  wheelSet: WheelSet;
  currency: string;
  canSelect: boolean;
  /** The wheel cards of one feature group. */
  children: React.ReactNode;
};

/** The wheel set as one radio group; without a standard wheel, "None selected" is a choice. */
export function WheelSetGroup(props: Props) {
  return (
    <div role="radiogroup" aria-label={getNewVehicleEnumLabel('featureKind', 'wheel', t)}>
      <Grid columns={[1, 1, 2, 2]} spacing={3}>
        {props.children}
        <Show when={isNil(props.wheelSet.standardWheel)}>
          <OptionCard
            title={t('entity.newVehicle.labels.noneSelected', 'None selected')}
            currency={props.currency}
            control="radio"
            name={WHEEL_GROUP_NAME}
            isSelected={isNil(props.wheelSet.checkedWheelId)}
            isDisabled={!props.canSelect || isNotNil(props.wheelSet.wheelLock)}
            isLocked={false}
            reason={props.wheelSet.wheelLock?.reason}
            onToggle={props.wheelSet.clearWheels}
          />
        </Show>
      </Grid>
    </div>
  );
}
